import PollCard from 'components/Polls/PollCard'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { PollUtils } from 'server/utils/poll-utils'
import { cn } from 'utils'
import { PollChoiceViewModel } from 'models/poll-choice-viewmodel'
import styles from './RightMenu.module.scss'
import FriendListNew from 'components/_shared/FriendList/FiendListNew'
import { useAppUser } from 'components/_hooks'


interface OwnProps {
  isOpened: boolean
  setIsRightMenuOpened?: (isOpen) => void
}

const RightMenuNew = ({ isOpened }: OwnProps) => {
  const [activePoll, setActivePoll] = useState<PollChoiceViewModel>(null)
  const user = useAppUser()
  const isUserLoggedIn = !!user

  const loadActivePoll = async () => {
    const result = await PollUtils.GetActivePoll()
    if (!result.isError && result.data) {
      setActivePoll(result.data)
    }
  }

  useEffect(() => {
    void loadActivePoll()
  }, [])

  return (
    <div className={cn('col-auto', 'p-0', styles.rightMenuWrapper)}>
      <nav
        className={
          cn(
            'd-flex flex-column justify-content-start align-items-start p-0-15', styles.rightMenu,
            isOpened && styles.rightMenuOpened,
          )
        }
      >
        {isUserLoggedIn && (
          <FriendListNew />
        )}

        {activePoll && (
          <>
            <div className={cn(styles.rightMenu__header, styles.rightMenu__headerBlue)}>KOMBATLINK POLL</div>
             <PollCard poll={activePoll} getPolls={loadActivePoll} />
          </>
        )}

        <hr className={styles.rightMenu__hr} />
        <div className={styles.rightMenu__privacy}>
          <Link to="/terms-of-service">Terms and Conditions</Link>
          <span>{' - '}</span>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
        <div className={styles.rightMenu__copyright}>@ Copyright Kombatlink.com</div>
      </nav>
    </div>
  )
}

export default RightMenuNew
